<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Lançamento Bancário</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroFluxoBancario" ref="formCadastroFluxoBancario" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.data" label="Data" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.data" no-title dense outlined/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete v-model="item.bancoId" :items="bancos" item-text="codigoNome" item-value="id" :rules="fieldRules" label="Banco" dense outlined/>
                            <!-- <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/> -->
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.descricao" label="Descrição" :rules="fieldRules" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select v-model="item.planoContaId" label="Plano de Contas" :items="planoContas" item-value="id" item-text="descricao" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="item.planoContaItemId" label="Plano de Contas (Item)" :items="planoContaItens" item-value="id" item-text="descricao" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.tipoStr" label="Tipo" disabled dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field type="number" v-model.number="item.valor" label="Valor" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field type="number" v-model.number="item.numeroCheque" label="Número Cheque" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import FluxoBancario from '@/core/domain/financeiro/FluxoBancario';
import TipoFluxoBancarioEnumService from '@/core/services/financeiro/TipoFluxoBancarioEnumService';
import BancoService from '@/core/services/financeiro/BancoService';
import PlanoContaService from '@/core/services/financeiro/PlanoContaService';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroFluxoBancario' in this.$refs)
                this.$refs.formCadastroFluxoBancario.resetValidation();
        },
        "item.planoContaId": function(){
            if (this.item.planoContaId > 0){
                let planoConta = this.planoContas.find(x => x.id == this.item.planoContaId);
                this.item.tipo = planoConta.tipo == 'D' ? 'S' : 'E';
                this.item.tipoStr = planoConta.tipoStr;
                this.planoContaItens = planoConta.itens;

                if (this.planoContaItens.length > 0){
                    this.item.planoContaItemId = this.planoContaItens[0].id;
                }
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new FluxoBancarioService(),
        valid: true,
        dialog: false,
        isLoading: false,
        tipos: [],
        bancos: [],
        planoContas: [],
        planoContaItens: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroFluxoBancario.validate()) {

                this.salvando = true;

                let modelo = new FluxoBancario(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', `Operação realizada com sucesso! <br/> Código: ${res.data.id}`, res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();

                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
            
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        let bancoService = new BancoService();
        bancoService.Listar()
            .then(
                res => {
                    const bancoDireto = res.data.items;

                    bancoDireto.forEach(x => {
                        if(x.situacao == 'A'){
                            this.bancos.push(x);
                        }
                    });
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        let planoContaService = new PlanoContaService();
        planoContaService.ListarTudo("Itens.PlanoContaContabil, Itens.PlanoContaContabilLivre, Itens.PlanoContaContabilRestrito")
            .then(
                res => {
                    this.planoContas = res.data.items.filter(x => x.id > 0);
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

    }
}
</script>